import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { IconClose, InformationalScreen, config as parallaxConfig, useTheme, } from '@adc/parallax-component-library';
import axios from 'axios';
import styled, { css } from 'styled-components';
import { MainContainer, TopHeaderBackArrow } from 'Components/utility';
import { getDocumentPathFromLanguage } from 'Utilities/dataHelpers';
import i18n from 'Utilities/i18n';
import log from 'Utilities/log';
import mediator from 'Utilities/mediator';
const addPxInFontSize = (str) => str + 'px';
const mapStateToProps = ({ config, env: { phoneLanguage }, nav: { query } }) => {
    return {
        files: config.documentPaths.files,
        phoneLanguage,
        isAccountProfile: query.accountProfile === 'true' ? true : false,
    };
};
const connector = connect(mapStateToProps);
const DocumentView = styled.div `
  ${(props) => css `
    background-color: ${props.neutralBackground};

    margin-top: -16px;

    h1 {
      color: ${props.textTitle};
      margin: 0;
      font-size: ${props.fontSizeHeadlineBaseStrong};
      font-family: 'BrandonText';
    }
    h2 {
      color: ${props.textTitle};
      font-family: 'BrandonText';
      font-size: ${props.fontSizeBodyBaseDefault};
    }
    h3 {
      color: ${props.textTitle};
    }
    p {
      color: ${props.text100};
      font-size: ${props.fontSizeBodyBaseDefault};
    }
    table {
      color: ${props.text100};
      text-align: left;
      border-collapse: collapse;
    }
    li {
      color: ${props.text100};
      font-size: ${props.fontSizeBodyBaseDefault};
    }
    a:link {
      color: ${props.textTitle};
    }
    a:visited {
      color: ${props.textTitle};
    }
    strong {
      color: ${props.text100};
      font-size: ${props.fontSizeBodyBaseDefault};
    }
    table,
    th,
    td {
      border: 1px solid ${props.text100};
    }
    th,
    td {
      padding: 8px;
    }

    .accordion .item input[type='checkbox'] {
      position: absolute;
      opacity: 0;
      z-index: -1;
    }

    .accordion .item input:target ~ .collapsible,
    .accordion .item input:checked ~ .collapsible {
      display: block;
    }

    .accordion .item input ~ .collapsible {
      display: none;
    }

    .accordion .item h3 {
      cursor: pointer;
    }
  `}
`;
const Document = ({ files, type, phoneLanguage, isAccountProfile, hideHeader, }) => {
    const [documentContentHtml, setDocumentContentHtml] = useState('');
    const theme = useTheme();
    const text = theme['text.100'];
    const background = theme['surface.background'];
    const textTitle = text.val;
    const text100 = text.val;
    const neutralBackground = background.val;
    const fontSizeBodyBaseDefault = parallaxConfig.fonts.body.size['bodyBase.default'];
    const fontSizeHeadlineBaseStrong = parallaxConfig.fonts.body.size['h2.strong'];
    useEffect(() => {
        const mountDocument = async () => {
            try {
                // Gets just the path in the users language
                const documentPath = getDocumentPathFromLanguage(files[type], phoneLanguage);
                const { data: documentHtml } = await axios.get(documentPath);
                const bodyElement = /<body.*?>([\s\S]*)<\/body>/.exec(documentHtml);
                if (bodyElement && bodyElement.length) {
                    const docBodyElement = bodyElement[0];
                    setDocumentContentHtml(docBodyElement.concat('</br>'));
                }
            }
            catch (error) {
                log.error(error);
            }
        };
        mountDocument();
    }, [files, phoneLanguage, type]);
    const onNavButtonPressed = useCallback(() => {
        mediator.publish('router:back');
    }, []);
    const title = type === 'termsOfUse'
        ? i18n.t('Global.microcopy.common.termsOfUse')
        : i18n.t('Global.microcopy.common.privacyNotice');
    return (React.createElement(MainContainer, null,
        React.createElement(InformationalScreen, { topNavigationProps: !hideHeader
                ? !isAccountProfile
                    ? {
                        animatedTitle: true,
                        title: title,
                        buttonStart: {
                            element: React.createElement(TopHeaderBackArrow, { testID: "Document.go-back" }),
                            label: i18n.t('Document.go-back'),
                            onPress: onNavButtonPressed,
                        },
                        testID: 'Document.actionTitle',
                    }
                    : {
                        title: title,
                        buttonStart: {
                            element: React.createElement(IconClose, { testID: "Document.close" }),
                            label: i18n.t('Document.close'),
                            onPress: onNavButtonPressed,
                        },
                        testID: 'Document.title',
                    }
                : undefined, testID: "Document" },
            React.createElement(InformationalScreen.Page, null,
                React.createElement(InformationalScreen.Content, null,
                    React.createElement(DocumentView, { fontSizeBodyBaseDefault: addPxInFontSize(fontSizeBodyBaseDefault), fontSizeHeadlineBaseStrong: addPxInFontSize(fontSizeHeadlineBaseStrong), text100: text100, textTitle: textTitle, neutralBackground: neutralBackground, dangerouslySetInnerHTML: { __html: documentContentHtml } }))))));
};
export default connector(Document);
